module["exports"] = ["com", "mx", "info", "com.mx", "org", "gob.mx"];